import React from "react"

import CompanyLayout from "components/Layout/CompanyLayout"
import CreateYourEventComponent from "components/CreateYourEvent/CreateYourEventComponent"
import useWindowSize from "hooks/useWindowSize"
import CreateYourEventComponentMobile from "components/CreateYourEvent/Mobile/CreateYourEventMobile"
import { NextSeo } from "next-seo"
import { useLang } from "hooks/useLang"

export const getServerSideProps = async () => {
    return {
        props: {},
    }
}

const CreateYourEventPage = () => {
    const { isMobile } = useWindowSize()
    const { isAr } = useLang()

    const pageTitle = isAr
        ? "اصنع فعاليتك | باس تيكتس"
        : "Create Your Event | PassTickets"

    const pageDescription = isAr
        ? "وجهة رقمية تحسبها خيال بس تعيشك تجارب واقعية"
        : "A digital destination that makes your imagination come true and gives you real experiences"

    return (
        <>
            <NextSeo
                title={pageTitle}
                description={pageDescription}
                openGraph={{
                    title: pageTitle,
                    description: pageDescription,
                    type: "website",
                    locale: isAr ? "ar_SA" : "en_US",
                    images: [
                        {
                            url: "https://cdn.pass-tickets.com/frontend/Desktop-1-min_jmdtg2.png",
                            width: 800,
                            height: 600,
                            alt: pageTitle,
                        },
                        // {
                        //     url: "https://cdn.pass-tickets.com/frontend/hero2.png",
                        //     width: 800,
                        //     height: 600,
                        //     alt: pageTitle,
                        // },
                    ],
                }}
            />
            <CompanyLayout>
                <div>
                    {isMobile ? (
                        <CreateYourEventComponentMobile />
                    ) : (
                        <CreateYourEventComponent />
                    )}
                </div>
            </CompanyLayout>
        </>
    )
}
CreateYourEventPage.theme = "dark"

export default CreateYourEventPage
